// extracted by mini-css-extract-plugin
export var worldmap = "WorldMap-module--worldmap--2IaSU";
export var worldmap__img = "WorldMap-module--worldmap__img--aoIxB";